/* Bean Shipper · Note for the roaster (snippets/bs-sub-note.liquid).
   Counts characters, and leaves a blank note out of the cart: on submit it disables an empty field, so
   the theme's ajax cart (a document-level submit listener that reads FormData) skips it; the field is
   re-enabled straight after. This listener sits on the form itself, so it always runs first. */
(function () {
  'use strict';
  function init(box) {
    if (box.__bsNote) return;
    box.__bsNote = true;
    var f = box.querySelector('[data-bs-note-field]');
    var c = box.querySelector('[data-bs-note-count]');
    if (!f) return;
    var max = parseInt(f.getAttribute('maxlength'), 10) || 200;
    function count() { if (c) c.textContent = f.value.length + '/' + max; }
    f.addEventListener('input', count);
    count();
    if (f.form) {
      f.form.addEventListener('submit', function () {
        var v = f.value.replace(/\s+/g, ' ').trim();
        if (!v) {
          f.disabled = true;
          setTimeout(function () { f.disabled = false; }, 0);
        } else if (v !== f.value) {
          f.value = v;
          count();
        }
      });
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-bs-note]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('pageshow', boot);
})();
